<template>
  <CustomDialog
    v-model="dialog"
    ref="customDialog"
    title="Novidade na plataforma!!!"
    hideFooter
    @cancel="close()"
  >
    <div>
      <v-img
        class="rounded-xl mb-4"
        :src="require(`@/assets/games/scratch-news-banner.jpeg`)"
        height="15rem"
      />

      <div class="text-body-1 font-weight-bold mb-3">
        Loja de pontos e raspadinhas
      </div>

      <p>
        Agora ficou ainda mais divertido jogar! 🎉 A cada partida, você acumula
        pontos e XP para subir de nível, a cada nível voce ganha mimos na nossa
        Trilha de Recompensas.
      </p>

      <p>
        Com seus pontos, você pode visitar a Loja de Pontos e trocar por
        boosters. E a grande novidade:
        <strong>Raspadinhas!</strong> 🥳 Cada raspadinha pode revelar prêmios
        instantâneos – é só raspar e torcer para ganhar!
      </p>

      <p>Aproveite, divirta-se e boa sorte! 🍀</p>

      <div class="d-flex align-center justify-center">
        <v-btn class="btn" color="primary" @click="close()"> Fechar </v-btn>
      </div>
    </div>
  </CustomDialog>
</template>

<script>
import CustomDialog from "@/components/customDialog/CustomDialog";

export default {
  name: "News",

  components: {
    CustomDialog,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
